import urljoin from 'url-join';
import ky from './kyInstance';

import { BASE_PATH, withAuthorizationHeader } from '..';

export const getLibrary = async () => {
  return ky.get(urljoin(BASE_PATH, 'ebooks/list'), {
    headers: withAuthorizationHeader(),
  });
};